module.exports = __webpack_public_path__ + "f895ed4dd2d29aeba09052d343873ecc.pdf";